import * as urls from '../../routes';
import { OverviewBottomNavigation } from './components/OverviewBottomNavigation';
import { reducer as overviewReducer } from './duck';
import { OverviewRoute } from './route';

export const overviewPageUrl = urls.overviewPage;
export const overviewPath = `(${urls.overviewPage}|${urls.insightsPage})`;

export { OverviewRoute, overviewReducer, OverviewBottomNavigation };
